import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

export type ToothPosition = 'incisal' | 'medio' | 'gingival';

@Component({
  selector: 'app-tooth-diagram',
  templateUrl: './tooth-diagram.component.html',
  styleUrls: ['./tooth-diagram.component.css']
})
export class ToothDiagramComponent implements OnChanges
{
  /** 'upper' | 'lower' — defines label order top-to-bottom */
  @Input() arch: 'upper' | 'lower' = 'lower';
  /** Current selected position */
  @Input() selected: ToothPosition = 'medio';
  /** Emits when user clicks a zone */
  @Output() selectedChange = new EventEmitter<ToothPosition>();

  zones: { key: ToothPosition; label: string; recommended: boolean }[] = [];

  ngOnChanges(): void
  {
    this.zones = this.arch === 'lower'
      ? [
          { key: 'incisal', label: 'Incisal',  recommended: false },
          { key: 'medio',   label: 'Medio',    recommended: true  },
          { key: 'gingival',label: 'Gingival', recommended: false },
        ]
      : [
          { key: 'gingival',label: 'Gingival', recommended: true  },
          { key: 'medio',   label: 'Medio',    recommended: false },
          { key: 'incisal', label: 'Incisal',  recommended: false },
        ];
  }

  select(zone: ToothPosition): void
  {
    this.selected = zone;
    this.selectedChange.emit(zone);
  }
}
